import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';  // Ensure this file exists and has no issues
import App from './App';  // Ensure the path to App is correct
import { BrowserRouter } from 'react-router-dom';  // Import BrowserRouter for routing

const rootElement = document.getElementById('root');

if (!rootElement) {
  console.error('Root element not found! Please check your HTML file.');
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <BrowserRouter> {/* Wrap App with BrowserRouter for routing */}
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
}
